import { gql } from 'apollo-boost';

export const AI_CHAT_COMPLETION = gql`
    mutation ($data: ChatCompletionInput!) {
        aiChatCompletion(data: $data) {
            content
            provider
            model
            usage {
                promptTokens
                completionTokens
                totalTokens
            }
            creditsUsed
            remainingCredits
        }
    }
`;
